// extracted by mini-css-extract-plugin
export default {"root":"PaymentAllocation_root__MWgDA","amount":"PaymentAllocation_amount__HxIaq","status-ready":"PaymentAllocation_status-ready__fNdIC"};